import apiService from "./globalService"

export const PageService = ()=> {
    return {
        getPage: (slug: string) => {
            return apiService.get(`/wp-json/wp/v2/pages?slug=${slug}`);
        }
    }   
}
